import { useEffect } from 'react'
import { usePanelHistoryTop } from 'weblite-router'
import { Divider } from '@mui/material'
import { AddUserIcon } from '$common/icons'
import { MenuIcon } from '$common/icons/menu'
import { EmptyStateList } from '$common/empty-state-list'
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { withSearchableListPage } from '$common/searchable-list-page'
import { closeContacts, openAddContact } from '$logic/router'
import { showContactMenu } from '$comp/modals/menus/contact-menu'
import {
  useSearchedSignedUpContactIds,
  useSignedUpContactIds,
} from '$logic/contacts/react-hook'
import { SignedUpContact } from '$logic/contacts/types'
import { t } from '$i18n'
import { getPvByUserId } from '$logic/pv'
import { openRoom } from '$logic/opened-room'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'
import { SyncIOSContactsFab } from '$comp/_app/components/leftPanel/components/contacts/sync-ios-contacts-fab'
import { IS_CHROME, IS_IOS, IS_SAFARI } from '$func/environmentInfo'

const onSendMessage = async (userId: string) => {
  const { roomId } = (await getPvByUserId(userId)) || {}
  if (roomId) openRoom(roomId)
}

function ListItem({ id }: { id: string }) {
  return (
    <>
      <UserListItemWithStatus
        userId={id}
        hasDivider={false}
        onClick={() => onSendMessage(id)}
        SecondaryActionIcon={MenuIcon}
        onSecondaryActionIconClick={() => showContactMenu({ userId: id })}
      />
      <Divider variant="inset" />
    </>
  )
}

const Page = withSearchableListPage<SignedUpContact, null, string>({
  appBarTitle: t('myAccount.contact'),
  ListItem,
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useSignedUpContactIds,
  searchHook: useSearchedSignedUpContactIds,
  actionButtonText: t('contacts.add'),
  actionButtonIcon: <AddUserIcon color="secondary" />,
  onActionButtonClick: openAddContact,
  onBack: closeContacts,
  FAB: IS_IOS && IS_SAFARI ? SyncIOSContactsFab : undefined,
})

export function Contacts() {
  const panelTop = usePanelHistoryTop('profile')
  useEffect(() => {
    const [topPage] = panelTop?.location?.split('/').slice(-1) ?? []
    if (topPage === 'CONTACTS') sendEventToTwa(TWA_EVENTS.SYNC_CONTACT)
  }, [panelTop])
  return <Page fetchHookParams={null} getSearchHookParams={query => query} />
}
